module.exports = __webpack_public_path__ + "biao4.png?9af6f84";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao4.png
 ** module id = 59
 ** module chunks = 0
 **/